import { motion } from "framer-motion";
import { REASONS } from "../lib/site";

export default function WhyChooseUs() {
  return (
    <section
      className="py-24 lg:py-32 border-t border-[#E5E5E0]"
      data-testid="why-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <span className="font-sans-body text-[11px] uppercase tracking-[0.3em] text-[#CC5500]">
            (Why JSE)
          </span>
          <h2 className="mt-4 font-serif-display text-4xl lg:text-5xl tracking-tightest text-[#1C1C1A] leading-tight">
            Four reasons people
            <br />
            <em className="font-light">keep calling us back.</em>
          </h2>
        </div>

        <div className="lg:col-span-7 lg:col-start-6 divide-y divide-[#E5E5E0] border-y border-[#E5E5E0]">
          {REASONS.map((r, i) => (
            <motion.div
              key={r.title}
              initial={{ opacity: 0, y: 14 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.08 * i }}
              className="py-8 grid grid-cols-12 gap-6 group hover:bg-[#FFFFFF] transition-colors duration-300 -mx-4 px-4"
              data-testid={`why-reason-${i}`}
            >
              <div className="col-span-2 font-serif-display text-2xl text-[#CC5500]">
                0{i + 1}
              </div>
              <div className="col-span-10">
                <h3 className="font-serif-display text-2xl lg:text-3xl text-[#1C1C1A] tracking-tight">
                  {r.title}
                </h3>
                <p className="mt-2 font-sans-body text-sm lg:text-base text-[#4A4A46] leading-relaxed max-w-lg">
                  {r.body}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
